import React from 'react';

import AutGeneralInfoTableA from '../../../blocks/aut-grid-table/autGeneralInfoTableA';
import AutGeneralInfoTableB from '../../../blocks/aut-grid-table/autGeneralInfoTableB';
import CustomSection from '../../custom-general/custom-section';

import { concatClassNames, formatTime } from '../../../../utils/utilities';
import { GeneralInformationData } from '../../../../utils/models';

import classNames from './style.module.scss';
import { APP_DATE_FORMAT } from '../../../../utils/constants';

const ExxonmobilAutGeneralInformation: React.FC<GeneralInformationData> = ({
	autEquipmentInformation,
	objectInformation,
	systemSettings,
}) => {
	const renderGrid = (title: string, value: string | number) => {
		return (
			<div className="row ">
				<div className={concatClassNames([classNames.generalInformationGridTitle, 'col-5'])}>
					{title}
				</div>
				<div className={concatClassNames([classNames.generalInformationGridValue,'col'])}>
					{value}
				</div>
			</div>
		);
	};

	return (
		<CustomSection sectionTitle="General Information">
			<div className="container-fluid overflow-hidden">
				{renderGrid('Acceptance Code', objectInformation.acceptanceCode)}
				{renderGrid('Tested Welds', objectInformation.testedWelds)}
			</div>

			<div className={classNames.generalInformationSection}>
				Object Information
			</div>
			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col">
						{renderGrid('Year of Manufacture', objectInformation.manufactureYear)}
						{renderGrid('Nominal Thickness (MM)', objectInformation.nominalThickness)}
					</div>
					<div className="col">
						{renderGrid('Manufacturing Code',objectInformation.manufacturingCode)}
						{renderGrid('Couplant Used', objectInformation.couplantUsed)}
					</div>
				</div>
				<div className="row">
					<div className="col">
						{renderGrid('Material', objectInformation.material)}
					</div>
					<div className="col">
						{renderGrid('Calibration Block', objectInformation.calibrationBlock)}
					</div>
					<div className="col">
						{renderGrid('Eq. Size OD (inch)', objectInformation.objectSize)}
					</div>
				</div>
			</div>

			<div className="container-fluid overflow-hidden">
			</div>

			<div className={classNames.generalInformationSection}>
				AUT Equipment Details
			</div>
			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col">
						{renderGrid('Equipment Name', autEquipmentInformation?.autSolution as string)}
					</div>
					<div className="col">
						{renderGrid('Equipment Brand', autEquipmentInformation?.autEquipmentBrand as string)}
					</div>
					<div className="col">
						{renderGrid('SN', autEquipmentInformation?.autSolutionSN as string)}
					</div>
				</div>
				<div className="row">
					<div className="col">
						{renderGrid('Inspection Probes', autEquipmentInformation?.inspectionProbes as string)}
					</div>
					<div className="col">
						{renderGrid('SN',autEquipmentInformation?.inspectionProbesSN as string)}
					</div>
				</div>
				<div className="row">
					<div className="col">
						{renderGrid('Date of Inspection', autEquipmentInformation?.dateOfInspection ? formatTime(autEquipmentInformation?.dateOfInspection, APP_DATE_FORMAT) : 'N/A')}
					</div>
					<div className="col">
						{renderGrid('Calibration Due Date', autEquipmentInformation?.calibrationDueDate ? formatTime(autEquipmentInformation?.calibrationDueDate, APP_DATE_FORMAT) : 'N/A')}
					</div>
				</div>
			</div>

			<div className={classNames.generalInformationSection}>
				System Settings
			</div>

			<div className="container-fluid overflow-hidden">
				<div className="row p-1">
					<div className="col p-0">
						<AutGeneralInfoTableA {...systemSettings} />
					</div>

					<div className="col p-0">
						<AutGeneralInfoTableB {...systemSettings} />
					</div>
				</div>
			</div>
		</CustomSection>
	);
};

export default ExxonmobilAutGeneralInformation;
